<template src="./paladin-note.html"></template>

<script>
import { NoteApi, ApiAddReplyRequest, ApiEntityPagedRequest } from '@chirhos/chirhos-api'
import { ChiRhos } from '@paladin/core'

import moment from 'moment'

let ChiRhosApi = new ChiRhos().api()

var noteApi = new NoteApi(ChiRhosApi)

export default {
  name: 'PaladinNote',
  filters: {
    ago: function(date) {
      return moment(date).fromNow()
    },
  },
  props: {
    noteData: {
      type: Object,
      required: true,
    },
    peopleEntityIdList: {
      type: Array,
      required: true,
      validator: (d) => d instanceof Array,
    },
    people: {
      type: Array,
      required: true,
      validator: (d) => d instanceof Array,
    },
  },
  data() {
    return {
      noteUserImageProps: { blank: true, blankColor: '#ccc', width: 45, height: 45, class: 'm1' },
      replyUserImageProps: { blank: true, blankColor: '#ccc', width: 35, height: 35, class: 'm1' },
      isReplying: false,
      replies: [],
      // peopleEntityIdList: [],
      // people: [],
      form: {
        newReplyText: '',
      },
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.loadReplies()
    })
  },
  methods: {
    loadReplies() {
      // console.log(this.noteData.modifiedByPerson)

      // Get Note author
      // personApi.Get({ request: new ApiEntityRequest(this.noteData.modifiedByPerson) }).then((result) => {
      //   this.people.push(result.data)
      // })

      // this.peopleEntityIdList.push(this.noteData.modifiedByPerson)
      this.$emit('cache-person', this.noteData.modifiedByPerson)
      if (this.noteData.entity.belongsToEntityType.toLowerCase() === 'person' && this.noteData.entity.belongsToEntityId)
        this.$emit('cache-person', this.noteData.entity.belongsToEntityId)

      noteApi
        .ListReplies({
          request: new ApiEntityPagedRequest(this.noteData.entity.entityId, 1, 100, false, null, null, null),
        })
        .then((result) => {
          if (result && result.data) {
            this.replies = result.data
            // Get reply author

            result.data.forEach((reply) => {
              this.$emit('cache-person', reply.modifiedByPerson)
              // this.peopleEntityIdList.push(reply.modifiedByPerson)
              // personApi.Get({ request: new ApiEntityRequest(reply.modifiedByPerson) }).then((response) => {
              //   this.people.push(response.data)
              // })
            })
          }
        })
    },
    getPerson(entityId) {
      let _person = this.people.find(function(obj) {
        if (obj.entity.entityId === entityId) {
          return obj
        } else return ''
      })

      return _person ? `${_person.entity.firstName} ${_person.entity.lastName}` : ''
    },
    submitNewGroupNoteReply(evt) {
      evt.preventDefault()

      let _reply = new ApiAddReplyRequest()
      _reply.text = this.form.newReplyText
      _reply.entityId = this.noteData.entity.entityId

      // console.log(_reply)

      noteApi.Reply({ request: _reply }).then((data) => {
        this.loadReplies()
        this.form.newReplyText = ''
      })
    },
  },
}
</script>
